import React from "react";
import "./ImageField.css";
import {useFormikContext} from "formik";
import {WalkMap} from "./types";

const ImageField = () => {
  const {setFieldValue} = useFormikContext<WalkMap>();

  return (
    <input
      className="ImageField form-control"
      id="file"
      name="file"
      type="file"
      onChange={event => {
        const f = event.target.files?.[0];
        if (!f) {
          return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(f);
        reader.onload = () => {
          const image = new Image();
          if (typeof reader.result === "string") {
            image.src = reader.result;
            image.onload = function () {
              setFieldValue("image", {
                url: reader.result,
                height: image.height,
                width: image.width,
              });
            };
          }
        };
        reader.onerror = () => console.error("failed to read file");
      }}
    />
  );
};

export default ImageField;
